import { StateNode } from '@ansys-internal/awf-angular/store';
import { Job } from '@ansys/cloud-angular-client';

export class JobState implements StateNode<Job[]> {
  key: string = 'jobs';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => Job[] = () => [];
}
